/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapDispatchToProps = exports.mapStateToProps = exports.name = exports.ModalBackground = void 0;

var react_1 = __importStar(require("react"));

var redux_1 = require("redux");

var body_scroll_lock_1 = require("body-scroll-lock");

var brightsmith_redux_1 = require("brightsmith-redux");

var name = 'ModalBackground';
exports.name = name;

var ModalBackground = function ModalBackground(_ref) {
  var Frame = _ref.Frame,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.backgroundRef = react_1.createRef();
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var modalOpen = this.props.modalOpen;

        if (this.backgroundRef) {
          var current = this.backgroundRef.current;

          if (modalOpen) {
            body_scroll_lock_1.disableBodyScroll(current);
          } else {
            body_scroll_lock_1.clearAllBodyScrollLocks();
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        body_scroll_lock_1.clearAllBodyScrollLocks();
      }
    }, {
      key: "handleBackgroundClick",
      value: function handleBackgroundClick(e) {
        var _a;

        var actions = this.props.actions;

        if (!e) {
          actions.ui.closeModal();
          return;
        }

        if (e.target === ((_a = this.backgroundRef) === null || _a === void 0 ? void 0 : _a.current)) {
          actions.ui.closeModal();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            classes = _this$props.classes,
            modalOpen = _this$props.modalOpen;
        return react_1.default.createElement(react_1.default.Fragment, null, modalOpen && react_1.default.createElement(Frame, {
          className: ['Modal__background', classes === null || classes === void 0 ? void 0 : classes.background],
          ref: this.backgroundRef,
          onClick: function onClick(e) {
            return _this2.handleBackgroundClick(e);
          },
          style: styles === null || styles === void 0 ? void 0 : styles.background
        }, children));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.ModalBackground = ModalBackground;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ui = state.ui;
  var modalOpen = ui.modalOpen;
  return {
    modalOpen: modalOpen
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      ui: {
        closeModal: redux_1.bindActionCreators(brightsmith_redux_1.Actions.Ui.closeModal, dispatch)
      }
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var style = function style(theme) {
  var _a;

  return {
    background: Object.assign({
      '-webkit-overflow-scrolling': 'touch',
      backgroundColor: 'rgba(0, 0, 0, .5)',
      bottom: 0,
      display: 'flex',
      left: 0,
      overflow: 'scroll',
      padding: 30,
      right: 0,
      top: 0,
      zIndex: 100,
      '@mobile': {
        position: 'absolute'
      },
      '@web': {
        position: 'fixed'
      }
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.ModalBackground) === null || _a === void 0 ? void 0 : _a.background)
  };
};

exports.style = style;